export function getEnumValues(enumObject: Record<string, string>): string[] {
  return Object.values(enumObject).filter(value => isNaN(Number(value)));
}